export default {"src":"/_next/static/media/for-creators-3.3ce4aa84.svg","height":1626,"width":1440};